import * as THREE from 'three'
import React, { useRef, useState, useTransition } from 'react'
import { useFrame } from '@react-three/fiber'
import { Instance } from '@react-three/drei'

export default function ConeFigure({
    index,
    hahaZoeSoundRef,
    bruderZoeSoundRef,
    hihiZoeSoundRef,
    dummkopfZoeSoundRef,
    iiiZoeSoundRef,
    mamaZoeSoundRef,
    papaZoeSoundRef,
    scheisseZoeSoundRef,
    scheisseAntonSoundRef,
    superAntonSoundRef,
    ahAntonSoundRef,
    baehAntonSoundRef,
    dreckAntonSoundRef,
    jaAntonSoundRef,
    neinAntonSoundRef,
    schwesterAntonSoundRef,
    ...props
}) {
    const [isPending, startTransition] = useTransition();
    const ref = useRef()
    const [hovered, setHover] = useState(false)
    const color = new THREE.Color()

    const sounds = [
        hahaZoeSoundRef,
        bruderZoeSoundRef,
        hihiZoeSoundRef,
        dummkopfZoeSoundRef,
        iiiZoeSoundRef,
        mamaZoeSoundRef,
        papaZoeSoundRef,
        scheisseZoeSoundRef,
        scheisseAntonSoundRef,
        superAntonSoundRef,
        ahAntonSoundRef,
        baehAntonSoundRef,
        dreckAntonSoundRef,
        jaAntonSoundRef,
        neinAntonSoundRef,
        schwesterAntonSoundRef,
    ]

    const playSound = () => { sounds[index % sounds.length].current.play() }
    //const playSound = () => { sounds[Math.floor(Math.random() * sounds.length)].current.play() }

    useFrame((state) => {
        //const t = state.clock.getElapsedTime() + random * 10000
        //ref.current.rotation.set(Math.cos(t / 4) / 2, Math.sin(t / 4) / 2, Math.cos(t / 1.5) / 2)
        //ref.current.position.y = Math.sin(t / 1.5) / 2
        ref.current.scale.x = ref.current.scale.y = ref.current.scale.z = THREE.MathUtils.lerp(ref.current.scale.z, hovered ? 1.2 : 1, 0.1)
        ref.current.color.lerp(color.set(hovered ? 'darkgreen' : 'white'), hovered ? 1 : 0.1)
    })

    return (
        <group {...props}>
            <Instance
                ref={ref}
                onPointerOver={(e) => {
                    startTransition(() => {
                        e.stopPropagation();
                        setHover(true);
                    });
                }}
                onPointerOut={(e) => {
                    startTransition(() => {
                        setHover(false);
                    });
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    startTransition(() => {
                        playSound();
                    });
                }}
            />
        </group>
    )
}
